export const NUM_NON_LOGIN_SHORTLIST_MAX_VEHICLES = 20;

export const SHORTLIST_CHECKBOX_SIZE = 16;
export const STAR_RATING_ICON_SIZE_DEFAULT = 14;
export const LIST_TYPE_LABEL_SIZE = 10;
export const ARROW_ICON_SIZE = 9;
export const ARROW_ICON_SIZE_IN_TOOLTIP = 6;
